/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'
import { JBP_AUDIT_COMPLIANCE_STATS_FRAGMENT } from './JBPAuditComplianceStatsFragment'

export const JBP_AUDIT_FRAGMENT = gql`
  fragment JBPAudit on JBPAudit {
    id
    store {
      id
    }
    contract {
      id
      plan {
        id
        name
      }
    }
    startTime
    endTime
    employee {
      id
      email
      firstName
      lastName
    }
    coldVaultStatus
    questionStatus
    complianceStats {
      ...JBPComplianceStats
    }
  }
  ${JBP_AUDIT_COMPLIANCE_STATS_FRAGMENT}
`
